import { useCallback } from 'react';

import { type OrderingMachineAction } from '@order/features-ordering';

import { useResetGroupOrderingState } from '../../../../hooks/useGroupOrderingState';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Returns the group-order leave success action that closes Bag and clears
 * participant state while preserving the host's location after cancellation.
 */
export const useHandleLeaveGroupOrderSuccess = (params: Params) => {
  const { closeBag } = params;

  const resetGroupOrderingState = useResetGroupOrderingState();

  // ─── Handlers ──────────────────────────────────────────────────────────────

  const handleLeaveGroupOrderSuccess = useCallback<OrderingMachineAction>(
    ({ context }) => {
      closeBag();

      const isHost = Boolean(context.cart.canSubmitOrder);

      if (isHost) return;

      resetGroupOrderingState();
    },
    [closeBag, resetGroupOrderingState],
  );

  return handleLeaveGroupOrderSuccess;
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Params = {
  closeBag: () => void;
};
